/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export var PersonSex;
(function (PersonSex) {
    PersonSex["MALE"] = "male";
    PersonSex["FEMALE"] = "female";
})(PersonSex || (PersonSex = {}));
